import { createFileRoute, redirect } from "@tanstack/react-router";
import { pageHead } from "@/lib/routeHead";

export const Route = createFileRoute("/deal-of-the-week")({
  head: () => pageHead({ title: 'Deal of the Week', description: "This week's featured RV deal at Rex & Sons RVs near Wilmington, NC.", path: '/deal-of-the-week' }),
  beforeLoad: () => {
    throw redirect({ href: "/p/deal-of-the-week" });
  },
});
